import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ScrollVertical } from 'elements/functional/ScrollVertical';
import { motion } from 'framer-motion';
import { EColors, EGrads, EHovers } from 'libs/styles/styling';
import { useRef, useState } from 'react';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    content: JSX.Element;
    footer: JSX.Element;
    background?: string;
    onClose: () => void;
}

export const SidebarModalWrapperMobile = (props: Props): JSX.Element => {
    const contentRef = useRef<HTMLDivElement>();
    const [height, setHeight] = useState(0);

    return (
        <S_SidebarModalWrapperMobile className={props.className}>
            <S_Wrap>
                <S_Top>
                    <S_Header onClick={props.onClose}>
                        <S_CloseWrapper>
                            <S_Close icon={['fal', 'xmark']} />
                        </S_CloseWrapper>
                    </S_Header>
                    <S_Mid>
                        <S_Padding />
                        <S_Relative
                            ref={(ref) => {
                                if (ref) {
                                    // console.log('Ref', ref.clientHeight);
                                    setHeight(ref.clientHeight);
                                }
                            }}
                        >
                            {height && (
                                <S_Radius
                                    initial={{ bottom: `-${height}px` }}
                                    animate={{ bottom: '0px' }}
                                    transition={{
                                        delay: 0.1,
                                        bottom: { duration: 0.2 },
                                        default: { ease: 'linear' }
                                    }}
                                    $background={props.background}
                                    ref={contentRef}
                                >
                                    <S_Content light={true}>{props.content}</S_Content>
                                </S_Radius>
                            )}
                        </S_Relative>
                        <S_Padding />
                    </S_Mid>
                </S_Top>
                {props.footer}
            </S_Wrap>
        </S_SidebarModalWrapperMobile>
    );
};

const S_SidebarModalWrapperMobile = styled.div`
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    right: 0;
    z-index: 2000000;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
`;

const S_Wrap = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

const S_Top = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    flex: 1;
    overflow: hidden;
`;

const S_Header = styled.div`
    height: 50px;
    flex-shrink: 0;
    display: flex;
    justify-content: flex-end;
`;

const S_Mid = styled.div`
    width: 100%;
    display: flex;
    flex: 1;
    overflow: hidden;
`;

const S_Relative = styled.div`
    width: 100%;
    position: relative;
    flex: 1;
    display: flex;
`;

const S_Radius = styled(motion.div)<{ $background: string }>`
    width: 100%;
    border-top-right-radius: 7px;
    border-top-left-radius: 7px;
    overflow: hidden;
    display: flex;
    background: ${(props) => (props.$background ? props.$background : EColors.WHITE)};
    position: absolute;
    height: 100%;
    bottom: 0px;
`;

const S_Content = styled(ScrollVertical)`
    width: 100%;
    height: unset;
    flex: 1;
`;

const S_Padding = styled.div`
    width: 10px;
    flex-shrink: 0;
`;

const S_CloseWrapper = styled.div`
    width: 30px;
    height: 30px;
    border-radius: 50%;
    color: ${EColors.DARK};
    background: ${EGrads.ACC1_GRAD};
    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin: 7px 10px 0 0;
    &:hover {
        box-shadow: ${EHovers.LIGHT2}, 0px 10px 30px rgba(0, 0, 0, 0.3);
    }
`;

const S_Close = styled(FontAwesomeIcon)`
    font-size: 15px;
    padding: 5px;
    display: flex;
`;
